import ListSimulateds from './ListSimulateds';
import ListSimulatedsSkeleton from '../ListSimulatedsSkeleton';

function CompletedSimulatedList({ simulateds, isLoading }) {
    if (isLoading) {
        return (
            <>
                <ListSimulatedsSkeleton />
                <ListSimulatedsSkeleton />
                <ListSimulatedsSkeleton />
            </>
        );
    }

    if (!Array.isArray(simulateds) || !simulateds.length) {
        return (
            <div className="alert alert-warning d-inline-flex my-5">
                Você ainda não realizou nenhum simulado.
            </div>
        );
    }

    return (
        <>
            {
                simulateds.map((simulated) => (
                    <ListSimulateds key={simulated.id} simulated={simulated} />
                ))
            }
        </>
    );
}

export default CompletedSimulatedList;
